import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.css'
import i18n from '../../i18n';

export const ConfirmAlert = (title: string, onConfirm: Function, onClose?: Function) =>
(confirmAlert({
    // @ts-ignore
    title: title ? i18n.t(title) : '',
    message: i18n.t("are you sure about doing this operation ?") || "",
    buttons: [
        {
            label: i18n.t('Yes'),
            onClick: () => onConfirm()
        },
        {
            label: i18n.t('No'),
            onClick: () => onClose ? onClose() : undefined
        }
    ],
    onClickOutside: () => onClose ? onClose() : undefined,
})
)

